import React, { useState } from 'react';
import ModalForm from '../ModalForm';
import { Box, Typography, Button } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

export default function BillingSummary(props) {
  const { itemCount, channelCount, info, error, onError } = props;
  const [openModal, setOpenModal] = useState(false);
  const [alert, setAlert] = useState(0);
  let items = 0;
  itemCount.forEach((element) => {
    if (element.id.trim().length > 0) items++;
  });
  let cost =
    parseInt(channelCount) === 1000
      ? 600
      : (parseInt(channelCount) - 5) * 3 + 50;
  let subtotal = items * cost;
  // let taxAmount = ((subtotal * taxRate) / 100.0).toFixed(2);
  // let grandTotal = subtotal + parseFloat(taxAmount);
  // let validationData = {};

  const checkValidation = () => {
    let canOpenModal = true;
    let validationData = { ...error };
    Object.keys(error).forEach((item, index) => {
      Object.keys(error[item]).forEach((subItem) => {
        switch (index + 1) {
          case 1:
            if (subItem === 'email')
              validationData = {
                ...validationData,
                userInfo: {
                  ...validationData.userInfo,
                  [subItem]: !(
                    info[item][subItem] &&
                    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                      info[item][subItem]
                    )
                  ),
                },
              };
            else
              validationData = {
                ...validationData,
                userInfo: {
                  ...validationData.userInfo,
                  [subItem]: info[item][subItem] ? false : true,
                },
              };
            break;
          case 2:
            validationData = {
              ...validationData,
              billInfo: {
                ...validationData.billInfo,
                [subItem]: info[item][subItem] ? false : true,
              },
            };
            break;
          case 3:
            if (subItem === 'cardNumber')
              validationData = {
                ...validationData,
                paymentInfo: {
                  ...validationData.paymentInfo,
                  [subItem]: info[item][subItem].indexOf('-') ? true : false,
                },
              };
            else
              validationData = {
                ...validationData,
                paymentInfo: {
                  ...validationData.paymentInfo,
                  [subItem]: info[item][subItem] ? false : true,
                },
              };
            break;
          default:
            break;
        }
      });
    });

    Object.keys(validationData).forEach((item, index) => {
      Object.keys(validationData[item]).forEach((subItem) => {
        if (canOpenModal === false) return;
        // if (item === 'billInfo') {
        //   if (info['userInfo']['checkBill'] === false) return;
        //   else if (validationData[item][subItem]) canOpenModal = false;
        // } else {
        if (validationData[item][subItem]) canOpenModal = false;
        // }
        // else if (item === 'paymentInfo') {
        //   if (info['paymentInfo']['select'] === 'paypal') return;
        //   else if (validationData[item][subItem]) canOpenModal = false;
        // }
      });
    });
    onError(validationData);

    return canOpenModal;
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />;
  });

  const CustomizedSnackbar = (props) => {
    const { status, alert, setAlert } = props;
    // const [snackOpen, setSnackOpen] = useState(alert);

    const handleClick = () => {
      setAlert(true);
    };

    const handleClose = (event, reson) => {
      if (reson === 'clickaway') {
        return;
      }
      setAlert(false);
    };
    if (status === 'success') {
      return (
        <Snackbar open={!!alert} autoHideDuration={6000} onClose={handleClose}>
          <Alert
            onClose={handleClose}
            severity='success'
            sx={{ width: '100%' }}
          >
            Payment successful
          </Alert>
        </Snackbar>
      );
    } else {
      return (
        <Snackbar open={!!alert} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity='error' sx={{ width: '100%' }}>
            Payment failed
          </Alert>
        </Snackbar>
      );
    }
  };

  return (
    <React.Fragment>
      <Typography variant='h5' mb={3}>
        Billing Summary
      </Typography>
      <Box mb={2} sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>Subtotal</Typography>
        <Typography>{`$${subtotal}`}</Typography>
      </Box>
      {/* <Box mb={2} sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>Tax amount</Typography>
        <Typography>{`$${taxAmount}`}</Typography>
      </Box> */}
      {/* <Divider />
      <Box
        mt={2}
        mb={2}
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Typography>Grand Total</Typography>
        <Typography>{`$${subtotal}`}</Typography>
      </Box> */}

      <Button
        variant='contained'
        fullWidth
        onClick={() => {
          checkValidation() && subtotal
            ? setOpenModal(true)
            : setOpenModal(false);
        }}
        // onClick={() => (subtotal ? setOpenModal(true) : setOpenModal(false))}
      >
        {'Pay $' + subtotal}
      </Button>
      <ModalForm
        open={openModal}
        onClose={() => setOpenModal(false)}
        subtotal={subtotal}
        info={info}
        setAlert={setAlert}
      />
      {alert === 1 ? (
        <CustomizedSnackbar status='success' alert={1} setAlert={setAlert} />
      ) : alert === 2 ? (
        <CustomizedSnackbar status='error' alert={2} setAlert={setAlert} />
      ) : null}
    </React.Fragment>
  );
}
